import React from 'react';
import { SingleSelection } from '../../../../../components';
import { EnumOperationType } from '../../../../../enum/EnumOperationType';
import { useTranslation } from '../../../../../hooks';
import { translatePrefix } from '../..';

interface IProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
}

const OperationTypeSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { translate, tc } = useTranslation();

  return (
    <SingleSelection
      label={label || tc('operationType')}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      clearSelect={onClear}
      enumData={EnumOperationType}
      nameFn={(name) => translate(`EnumOperationType.${name}`)}
    />
  );
};

export default OperationTypeSingleSelection;
